<template>
  <div class="summary" :class="{ 'pt-5': !currentBrand }">
    <h4>{{ _T('Item(s) Summary') }}</h4>
    <ul v-if="available_cart_items.length">
      <li
        class="summary-card"
        v-for="(item, key) in available_cart_items"
        :key="'checkout_item' + key"
      >
        <item v-if="item.item_type !== 'combo_item'" :item="item"></item>
        <combo-item v-else :item="item"></combo-item>
      </li>
    </ul>
    <empty-cart v-else></empty-cart>
  </div>
</template>
<script>
import Item from './Items/Item'
import { mapGetters } from 'vuex'
import ComboItem from './Items/ComboItem'
import EmptyCart from '../../Blocks/Cart/EmptyCart'

export default {
  name: 'Items',
  components: {
    ComboItem,
    Item,
    EmptyCart,
  },
  computed: {
    ...mapGetters(['_T', 'available_cart_items', 'currentBrand']),
  },
}
</script>
<style lang="scss" scoped>
.body-rtl {
  .summary {
    text-align: right;
    margin-right: 2rem;
    ul {
      padding-right: 0;
    }
  }
}
</style>
